import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { Field } from 'redux-form';

import TextField from 'components/fields/TextField';

import * as normalize from 'utils/normalize';
import sortInsurance from 'utils/sortInsurance';
import formatPrice from 'utils/formatPrice';

import hexToRgb from 'styles/hexToRgb';
import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  containerReimbs: {
    '& + $containerReimbs': {
      marginTop: 8,
    },
  },
  containerReimbsRecoupRebill: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  fieldRecoup: {
    width: 'calc(50% - 12px)',
  },
  fieldRebilled: {
    width: 'calc(50% - 12px)',
  },
  inputRootRecoup: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.validation[500])}, 0.2)`,
  },
  inputRootRebilled: {
    backgroundColor: `rgba(${hexToRgb(theme.palette.add[500])}, 0.2)`,
  },
  prevReimbsContainer: {
    display: 'inline-block',
    boxSizing: 'border-box',
    width: 'calc(50% + 12px)',
    verticalAlign: 'top',
  },
  typographyOriginalReimbs: {
    display: 'inline-block',
    // border: `1px solid ${theme.palette.grey[600]}`,
    borderRadius: 4,
    // padding: '5px 10px',
    fontSize: pxToRem(13),
    letterSpacing: pxToEm(0.25, 13),
    lineHeight: pxToEm(15, 13),
    color: `rgba(${hexToRgb(theme.palette.secondary[800])}, 0.4)`,
    // backgroundColor: theme.palette.grey[50],
    textDecoration: 'line-through',
  },
  typographyPrevRecoupment: {
    display: 'inline-block',
    // border: `1px solid ${theme.palette.grey[600]}`,
    borderRadius: 4,
    // padding: '5px 10px',
    fontSize: pxToRem(13),
    letterSpacing: pxToEm(0.25, 13),
    lineHeight: pxToEm(15, 13),
    color: `rgba(${hexToRgb(theme.palette.secondary[800])}, 0.4)`,
    backgroundColor: `rgba(${hexToRgb(theme.palette.validation[500])}, 0.12)`,
  },
});

class OrdersTableRowItemReimbs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focusValue: null,
    };

    this.onFieldFocus = this.onFieldFocus.bind(this);
  }

  onFieldFocus(event) {
    this.setState({
      focusValue: {
        [event.target.name]: event.target.value,
      },
    });
  }

  render() {
    const {
      namePrefix,
      onBlur,
      disabled,
      Insurance,
      className,
      orderLineInsuranceParam,
      classes,
    } = this.props;
    const { focusValue } = this.state;
    if (!Insurance || Insurance.length === 0) {
      return (
        <Field
          className={className}
          id={`${namePrefix}.Reimbs`}
          name={`${namePrefix}.Reimbs`}
          component={TextField}
          normalize={normalize.price}
          disabled={disabled}
          onBlur={(event, newValue) => {
            const values = {};
            values[namePrefix] = {
              Reimbs: newValue,
            };
            onBlur(values);
          }}
          size="sm"
          color="light"
          errorPlacement="left"
          fullWidth
        />
      );
    }
    return (
      <div>
        {sortInsurance(Insurance).map(insurance => {
          const currentOrderLineInsuranceParam = orderLineInsuranceParam.filter(item =>
            item.Insurance.ID === insurance.ID);
          const lastOrderLineInsuranceParam = currentOrderLineInsuranceParam[currentOrderLineInsuranceParam.length - 1];
          let isRecoupActive;
          let isRebillActive;
          let originalReimbs;
          let prevRecoupment;
          if (lastOrderLineInsuranceParam && lastOrderLineInsuranceParam.Reimbs
            && Number(lastOrderLineInsuranceParam.Reimbs) > 0) {
            isRecoupActive = true;
            const beforeLastOrderLineInsuranceParam = currentOrderLineInsuranceParam.length >= 3
              ? currentOrderLineInsuranceParam[currentOrderLineInsuranceParam.length - 2] : null;
            const originalOrderLineInsuranceParam = currentOrderLineInsuranceParam.length >= 3
              ? currentOrderLineInsuranceParam[currentOrderLineInsuranceParam.length - 3] : null;
            prevRecoupment = beforeLastOrderLineInsuranceParam ? beforeLastOrderLineInsuranceParam.Reimbs : null;
            originalReimbs = originalOrderLineInsuranceParam ? originalOrderLineInsuranceParam.Reimbs : null;
          }
          if (lastOrderLineInsuranceParam && lastOrderLineInsuranceParam.Reimbs
            && Number(lastOrderLineInsuranceParam.Reimbs) < 0) {
            isRebillActive = true;
            const beforeLastOrderLineInsuranceParam =
              currentOrderLineInsuranceParam[currentOrderLineInsuranceParam.length - 2];
              originalReimbs = beforeLastOrderLineInsuranceParam ? beforeLastOrderLineInsuranceParam.Reimbs : null;
          }
          return (
            <div
              key={insurance.ID}
              className={classNames(classes.containerReimbs, {
                [classes.containerReimbsRecoupRebill]: isRebillActive || prevRecoupment,
              })}
            >
              {isRebillActive && (
                <div className={classes.prevReimbsContainer}>
                  <Typography className={classes.typographyOriginalReimbs}>
                    {formatPrice(originalReimbs)}
                  </Typography>
                </div>
              )}
              {prevRecoupment && (
                <div className={classes.prevReimbsContainer}>
                  <Typography className={classes.typographyOriginalReimbs}>
                    ${formatPrice(originalReimbs).replace('$', '')}
                  </Typography>
                  <Typography className={classes.typographyPrevRecoupment}>
                    {formatPrice(prevRecoupment).replace('$', '')}
                  </Typography>
                </div>
              )}
              <Field
                className={classNames(className, {
                  [classes.fieldRecoup]: isRebillActive,
                  [classes.fieldRebilled]: prevRecoupment,
                })}
                inputRootClassName={classNames({
                  [classes.inputRootRecoup]: isRebillActive,
                  [classes.inputRootRebilled]: prevRecoupment,
                })}
                id={`${namePrefix}.orderLineInsuranceParam.insuranceID-${insurance.ID}.Reimbs`}
                name={`${namePrefix}.orderLineInsuranceParam.insuranceID-${insurance.ID}.Reimbs`}
                component={TextField}
                normalize={isRebillActive ? normalize.negativePrice : normalize.price}
                disabled={disabled}
                onFocus={this.onFieldFocus}
                onBlur={(event, newValue) => {
                  if (focusValue
                    && focusValue[`${namePrefix}.orderLineInsuranceParam.insuranceID-${insurance.ID}.Reimbs`] !== undefined
                    && focusValue[`${namePrefix}.orderLineInsuranceParam.insuranceID-${insurance.ID}.Reimbs`] !== newValue) {
                    const values = {
                      [namePrefix]: {
                        orderLineInsuranceParam: {},
                      },
                    };
                    values[namePrefix].orderLineInsuranceParam[`insuranceID-${insurance.ID}`] = {
                      Reimbs: newValue,
                    };
                    onBlur(values);
                  }
                  this.setState({ focusValue: null });
                }}
                size="sm"
                color="light"
                errorPlacement="left"
                fullWidth
              />
            </div>
          );
        })}
      </div>
    );
  }
}

OrdersTableRowItemReimbs.propTypes = {
  namePrefix: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
  Insurance: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })),
};

OrdersTableRowItemReimbs.defaultProps = {
  className: '',
  onBlur: () => {},
  Insurance: [],
  disabled: false,
};

export default withStyles(styles)(OrdersTableRowItemReimbs);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersTable/OrdersTableRowItemReimbs.js